import classNames from "./pdf.module.scss";
import russelsmithLogo from "../../../assets/images/brand.png";

interface PDFLogoDetailsProps {
  organizationLogo: string;
  organizationName: string;
}

const PDFLogoDetails = (props: PDFLogoDetailsProps) => {
  return (
    <div className="d-flex justify-content-between mb-3">
      <div className={classNames.logo}>
        <img src={props.organizationLogo} alt={props.organizationName} />
      </div>
      <div className={classNames.logo}>
        <img src={russelsmithLogo} alt="Russel Smith" />
      </div>
    </div>
  );
};

export default PDFLogoDetails;
